import {linkedPackage} from 'lincd/lib/utils/Module';

export const {
  linkedComponent,
  linkedComponentClass,
  linkedShape,
  linkedUtil,
  linkedOntology,
  registerPackageModule,
  registerPackageExport,
  packageExports,
  packageName,
} = linkedPackage('lincd-authenticator');
